import { Api } from '@/services/Api';

export default {
  getProcesses(keyword = '') {
    return Api().get(`/Process${keyword ? '?Keyword=' + keyword : ''}`);
  },
  getProcess(id) {
    return Api().get(`/Process/${id}`);
  },
  getProcessWithActivities(id) {
    return Api().post(`/Process/GetFullProcessInfo`, { processId: id });
  },
  saveProcess(body) {
    return Api().post(`/Process`, body);
  },
  deleteUsers(processes) {
    return Api().post(`/Process/DeleteTree`, processes);
  },
  postProcesses({ processes, isPost }) {
    return Api().post(`/Process/PostTree?isActive=${isPost}`, processes);
  },
  getInstanceHistory(wfInstanceID) {
    return Api().get(`/Process/GetInstancehistory?wfInstanceID=${wfInstanceID}`);
  }
};
